/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bi_Dashboard_Authoring_Restrict_LabelInputs */



/**
* | output |
* | --- |
* | "Restrict dashboard authoring to admins" |
*
* @param {Bi_Dashboard_Authoring_Restrict_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bi_dashboard_authoring_restrict_label = /** @type {((inputs?: Bi_Dashboard_Authoring_Restrict_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bi_Dashboard_Authoring_Restrict_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dashboard-Erstellung auf Admins beschränken")
	return /** @type {LocalizedString} */ ("Restrict dashboard authoring to admins")
});